import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { filterRelatedAlerts } from '../utils/alerts'
import { bp } from '../globalStyles'
import { Page, Container } from '../components/common'
import Meta from '../components/Meta'
import Schema from '../components/Schema'
import MapGL from '../components/MapGL'
import Header from '../components/Header'
import TrackCard from '../components/TrackCard'
import TextCard from '../components/TextCard'
import AlertCard from '../components/AlertCard'
import CardContainer from '../components/CardContainer'
import SectionTitle from '../components/SectionTitle'
import NoMatch from '../views/NoMatch'

const LocationSingle = ({
  locations,
  match,
  alerts,
  linkContentRelations,
  route
}) => {
  const item = locations.find(item => item.fields.slug === match.params.slug)
  if (!item) return <NoMatch route={route} />

  if (item) {
    const {
      title,
      description,
      coordinates,
      slug,
      mainImage,
      images = [],
      tracks
    } = item.fields

    console.log(title, description)

    return (
      <Page>
        <Helmet title={title} />
        <Meta
          title={title}
          description={description}
          url={`https://discoverspringbrook.com/locations/${slug}`}
        />
        <Schema
          type='Place'
          geo={{
            latitude: coordinates.lat,
            longitude: coordinates.lon
          }}
          description={description}
          url={`https://discoverspringbrook.com/locations/${slug}`}
          name={title}
        />
        <Header title={title} images={[mainImage, ...images]} slider large />
        <Container desktopOnly>
          {description && (
            <TextCard content={linkContentRelations(description)} />
          )}

          {filterRelatedAlerts({ alerts, doc: item }).map(alert => (
            <AlertCard key={`AlertCard-${alert.id}`} {...alert} />
          ))}

          {tracks && (
            <Fragment>
              <SectionTitle title='Walks' subtitle={`connected to ${title}`} />
              <TrackCards desktopOnly>
                {tracks.map(track => (
                  <TrackCard key={track.sys.id} track={track} />
                ))}
              </TrackCards>
            </Fragment>
          )}
          {coordinates && (
            <Link
              to={{
                pathname: '/map',
                hash: `#${slug}`
              }}
            >
              <MapGL
                locations={[item]}
                center={[coordinates.lon, coordinates.lat]}
                zoom={13}
                inset
              />
            </Link>
          )}
        </Container>
      </Page>
    )
  } else {
    return <div className='loading' />
  }
}

LocationSingle.propTypes = {
  locations: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired
}

const TrackCards = styled(CardContainer)`
  @media (${bp.desktop}) {
    margin-bottom: 3rem;
    margin-top: 1.5rem;
  }
`

export default LocationSingle



// WEBPACK FOOTER //
// ./src/views/LocationSingle.js